angular.module('unergie.main')
.filter('callStatus', () =>
    function (val) {
        switch (val) {
            case 'initial': return 'Initial'
            case 'answered': return 'En cours'
            case 'done': return 'Terminé'
            default: return val
        }
    },
)
